import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const TaskCreationPage = withSuspense(
	lazy(async () => await import('./task-creation-page.component')),
	PageLoader,
);
